import { render } from "./Frame.vue?vue&type=template&id=4a5cad5e&scoped=true"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"

import "./Frame.vue?vue&type=style&index=0&id=4a5cad5e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5cad5e"]])

export default __exports__